class Top {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    if (window.matchMedia('(max-width: 767px)').matches) {
      // ウィンドウサイズ768px以下のときの処理
      const swiper = new Swiper(".blog-swiper", {
        slidesPerView: "auto",
        loop:true,
        spaceBetween: 20,
      });
    }

    if (window.matchMedia('(min-width: 768px)').matches) {
      // サービス ホバーアクション
      const serviceTrigger = document.querySelectorAll(".js-service-link")
      const serviceImg = document.querySelectorAll(".js-service-img")
      
      serviceImg[0].classList.add("is-active")

      serviceTrigger.forEach((item, i) => {
        item.addEventListener("mouseover", () => {
          for (let index = 0; index < serviceImg.length; index++) {
            const ele = serviceImg[index];


            if(i === index ){
              ele.classList.add("is-active")
            }else{
              ele.classList.remove("is-active")
            }

          }
        })
      })
    }


  }
}